import { z } from "zod";

const OpaqueIdSchema = z.uuid();
const RequestIdSchema = z.string().regex(/^req_[0-9a-f-]{36}$/u);

export const StagingRuntimeProofRequestSchema = z
  .object({
    proof_id: OpaqueIdSchema,
    value: z.string().min(1).max(200),
  })
  .strict();

export const StagingRuntimeProofResponseSchema = z
  .object({
    proof_id: OpaqueIdSchema,
    d1_persisted: z.literal(true),
    r2_roundtrip: z
      .object({ value_hash: z.string().regex(/^[0-9a-f]{64}$/u), deleted: z.literal(true) })
      .strict(),
    queue_job_id: OpaqueIdSchema,
    workflow_job_id: OpaqueIdSchema,
    workflow_instance_id: z.string().min(1).max(200),
    request_id: RequestIdSchema,
  })
  .strict();

export const BackgroundJobSchema = z
  .object({
    id: OpaqueIdSchema,
    workspace_id: OpaqueIdSchema,
    source: z.enum(["queue", "workflow"]),
    type: z.string().min(1).max(160),
    schema_version: z.number().int().min(1),
    status: z.enum(["accepted", "running", "completed", "failed"]),
    attempts: z.number().int().min(0),
    result_json: z.string().refine((value) => {
      try {
        JSON.parse(value);
        return true;
      } catch {
        return false;
      }
    }, "result_json must contain valid JSON"),
    created_at: z.number().int(),
    updated_at: z.number().int(),
  })
  .strict();

export const BackgroundJobResponseSchema = z
  .object({ job: BackgroundJobSchema, request_id: RequestIdSchema })
  .strict();

export type StagingRuntimeProofRequest = z.infer<typeof StagingRuntimeProofRequestSchema>;
export type StagingRuntimeProofResponse = z.infer<typeof StagingRuntimeProofResponseSchema>;
export type BackgroundJob = z.infer<typeof BackgroundJobSchema>;
